import httpClient from "../http/http-client";
import { IEnergySupplierTariff, IPostEnergySupplierTariff } from './energy-supplier-tariff.model';

export default class EnergySupplierTariffService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IEnergySupplierTariff[]> {
    return this.http.get('energy-supplier-tariff')
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllActive(): Promise<IEnergySupplierTariff[]> {
    return this.http.get('energy-supplier-tariff?active=true')
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }


  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', energySupplierId?: string): Promise<{ count: number, rows: IEnergySupplierTariff[] }> {
    return this.http.get(`energy-supplier-tariff?nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${energySupplierId ? `&energySupplierId=${energySupplierId}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getOne(energySupplierTariffId: string): Promise<IEnergySupplierTariff> {
    return this.http.get(`energy-supplier-tariff/${energySupplierTariffId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(energySupplierTariff: IPostEnergySupplierTariff): Promise<IEnergySupplierTariff> {
    return this.http.post('energy-supplier-tariff', energySupplierTariff)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(energySupplierTariffId: string, energySupplierTariff: Partial<IPostEnergySupplierTariff>): Promise<IEnergySupplierTariff> {
    return this.http.patch(`energy-supplier-tariff/${energySupplierTariffId}`, energySupplierTariff)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async activate(energySupplierTariffId: string): Promise<IEnergySupplierTariff> {
    return this.http.patch(`energy-supplier-tariff/${energySupplierTariffId}/activate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async deactivate(energySupplierTariffId: string): Promise<IEnergySupplierTariff> {
    return this.http.patch(`energy-supplier-tariff/${energySupplierTariffId}/deactivate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}

